<template>
  <v-dialog v-model="dialogShow" persistent width="540">
    <v-card>
      <v-card-title class="tipsDialog-title">
        温馨提示
        <v-spacer></v-spacer>
        <p @click="hideDialog" class="tipsDialog-close iconfontFamily">&#xe60d;</p>
      </v-card-title>
      <v-card-text class="tipsDialog-mainAreaNoIcon">
        <div style="display: flex;width: 100%;height: 80px;line-height: 80px;justify-content: center;align-items: center">
          <p class="iconfontFamily" style="font-size: 60px;color: dodgerblue;margin-left: -10px">&#xe640;</p>
          <div style="margin-left: 40px;text-align: left">
          <p class="tipsDialog-mainAreaNoIcon-text" style="line-height: 25px">文件删除后无法恢复</p>
          <p class="tipsDialog-mainAreaNoIcon-text" style="line-height: 25px">确定删除？</p>
          </div>
        </div>
        <div class="tipsDialog-mainArea-btnLine">
          <v-btn @click="hideDialog" width="100" height="35" color="#F5F5F5">取消</v-btn>
          <v-btn @click="deleteFileOK" width="100" height="35" dark color="#1E3A8A" style="margin-left:50px;">确认</v-btn>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  name: "DeleteFileDialog",
  props:["dialogShow"],
  methods:{
    deleteFileOK(){
      this.$emit('deleteFileOK')
    },
    //隐藏弹窗
    hideDialog(){
      console.log(this.deleteFileId)
      this.$emit("closeDeleteFileDialog")
    }
  }
}
</script>

<style scoped>

</style>